import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";

interface Note {
    sort: number;
    comment: string;
}

interface CommentNoteSectionProps {
    type: string;
    curAccount: any;
    certificate: any;
    setCertificate: React.Dispatch<React.SetStateAction<any>>;
    orderId: any;
    showAccount: any;
    setIsSavedResult: React.Dispatch<React.SetStateAction<boolean>>;
    deleteNote: any;
    editable: boolean;
    setShowAdd: React.Dispatch<React.SetStateAction<boolean>>;
    setShowUpdate: React.Dispatch<React.SetStateAction<boolean>>;
    noteType: string;
    level?: boolean;
    isTaxSuit?: boolean;
    isHoaNote?: boolean;
    setIndex: React.Dispatch<React.SetStateAction<number>>;
    length?: number;
    updatedAccountIndexList?: any
}


export function CommentNoteSection({
    type,
    curAccount,
    certificate,
    setCertificate,
    showAccount,
    setIsSavedResult,
    deleteNote,
    editable,
    setShowAdd,
    setShowUpdate,
    isTaxSuit = false,
    noteType,
    level = false,
    isHoaNote = false,
    setIndex,
}: CommentNoteSectionProps) {
    const [certNotes, setCertNotes] = useState<Note[]>([]);
    const [updatedAccountIndexList, setupdatedAccountIndexList] = useState<any[]>([]);
    useEffect(() => {
        if (Array.isArray(curAccount)) {
            setCertNotes(curAccount);
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(curAccount)) {
            setCertNotes(curAccount);
        }
    }, [certificate, curAccount]);

    const sortNoteDraggableList = (props: DropResult) => {
        const sourceIndex = props.source.index;
        const destinationIndex = props.destination?.index;

        if (destinationIndex === undefined || sourceIndex === destinationIndex) return;

        const reorderedNotes = Array.from(certNotes);
        const [movedItem] = reorderedNotes.splice(sourceIndex, 1);
        reorderedNotes.splice(destinationIndex, 0, movedItem);

        const updatedNotes: Note[] = reorderedNotes.map((note, index) => ({
            ...note,
            sort: index + 1,
        }));

        const updatedCertificate = { ...certificate };

        if (isHoaNote) {
            const updatedAccounts = [...updatedCertificate.accounts];
            updatedAccounts[showAccount] = { ...updatedAccounts[showAccount], notes: updatedNotes };
            updatedCertificate.accounts = updatedAccounts;
        } else if (isTaxSuit && noteType === "taxSuitNotes") {
            const updatedAccounts = [...updatedCertificate.accounts];
            updatedAccounts[showAccount] = { ...updatedAccounts[showAccount], taxSuitNotes: updatedNotes };
            updatedCertificate.accounts = updatedAccounts;
        } else if (level && noteType === "certificate") {
            updatedCertificate.certificateNotes = updatedNotes;
        } else if (noteType === "accounts" && type === "Account Comments") {
            const updatedAccounts = [...updatedCertificate.accounts];
            updatedAccounts[showAccount] = { ...updatedAccounts[showAccount], accountNote: updatedNotes };
            updatedCertificate.accounts = updatedAccounts;
        }

        setCertificate(updatedCertificate);
        setupdatedAccountIndexList([...updatedAccountIndexList, showAccount]);
        setIsSavedResult(false);
        setCertNotes(updatedNotes);
    };


    return (
        <div className="col-lg-12 col-sm-12">
            <div>
                <div
                    className={
                        isHoaNote ? "flex justify-between p-2 border border-text-4 bg-highlight-1 text-text-0" : "p-1 border border-highlight-3  bg-highlight-3 text-text-0 flex justify-between"
                    }
                >
                    <b>
                        {type} ({curAccount?.length})
                    </b>
                    <span className="text-right">
                        <i
                            className="fa fa-plus-circle mr-2"
                            title="Add Note"
                            data-toggle="modal"
                            onClick={() => {
                                if (editable) {
                                    setShowAdd(true);
                                }
                            }}
                            data-keyboard="false"
                        />
                    </span>
                </div>
                <DragDropContext onDragEnd={sortNoteDraggableList}>
                    <div className={`scroll1 ${isHoaNote ? "hoa_assessment border border-highlight-1" : "assessment_info border border-highlight-3"}`}>
                        <div className="scroll certificate_notes_scroll">
                            {Array.isArray(certNotes) && certNotes.length === 0 && (
                                <div className={'p-2'}>
                                    <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0">
                                        <h3>No notes to display</h3>
                                    </div>
                                </div>
                            )}
                            <Droppable droppableId="droppable-1">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                        {certNotes.map((notes, i) => (
                                            <Draggable
                                                key={`${notes.sort}-${i}-${notes.comment}`}
                                                draggableId={`${notes.sort}-${i}-${notes.comment}`}
                                                index={i}
                                                isDragDisabled={!editable}
                                            >
                                                {(provided, snapshot) => (
                                                    <div
                                                        className={`row mr-2 ml-2 mt-2 mb-2 p-2 flex row-color item bg-text-0 ${snapshot.isDragging ? "dragging" : ""}`}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <div className="col-md-1 p-1  text-center">
                                                            <i
                                                                onClick={() => {
                                                                    if (editable) {
                                                                        setIndex(i);
                                                                        deleteNote(noteType, i);
                                                                    }
                                                                }}
                                                                className={`fas fa-trash delete-file mr-3 cursor-pointer ${isHoaNote ? 'text-highlight-1' : 'text-highlight-0'}`}
                                                            />
                                                        </div>
                                                        <div className="col-md-1 p-1 text-center cursor-pointer">
                                                            <i
                                                                title="Update Comment..."
                                                                data-toggle="modal"
                                                                onClick={() => {
                                                                    if (editable) {
                                                                        setIndex(i);
                                                                        setShowUpdate(true);
                                                                    }
                                                                }}
                                                                className={`fas fa-edit delete-file mr-3 cursor-pointer ${isHoaNote ? 'text-highlight-1' : 'text-highlight-0'}`}
                                                            />
                                                        </div>
                                                        <div
                                                            className="col-md-8 p-1"
                                                            style={{ whiteSpace: "pre-wrap" }}
                                                        >
                                                            {notes.comment}
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    </div>
                </DragDropContext>
            </div>
        </div>
    );
}